import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";
import { useSelector } from "react-redux/es/hooks/useSelector";
import 'react-toastify/dist/ReactToastify.css';

function Routes(){
    const isLogged = useSelector(state => state.userReducer.isLogged);
    if(isLogged){
        return(<AppRoutes/>);
    }else{
        return(<AuthRoutes/>);
    }
}
export default Routes;